import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import { TargetInputValuesType } from '@app/features/exportInputValues/hooks/useExportInputValues';
import ExportInputValuesStatus from '@app/store/transport-layer/document/export-input-values-jobs/ExportInputValuesStatus';

export type OrderPropertyType =
  | 'DOCUMENT_TITLE'
  | 'DOCUMENT_ID'
  | 'DOCUMENT_STATUS'
  | 'PARTICIPANT_NAME'
  | 'PARTICIPANT_EMAIL'
  | 'PARTICIPANT_PHONE'
  | 'DOCUMENT_COMPLETED_AT'
  | 'DOCUMENT_UPDATED_AT'
  | 'FOLDER_NAME';

interface StartExportInputValuesJobRequestBase {
  message: string | null;
  selectedInputValues?: TargetInputValuesType;
  order?: {
    orderType?: 'ASC' | 'DESC';
    property?: OrderPropertyType;
  };
}

interface StartExportInputValuesJobRequestByDocuments extends StartExportInputValuesJobRequestBase {
  documents: Array<string>; // 추출할 문서 id
}

interface StartExportInputValuesJobRequestByRequestMethods
  extends StartExportInputValuesJobRequestBase {
  requestMethods: Array<string>; // 문서목록 조회할 때 응답이 오는 creationInfo
}

interface StartExportInputValuesJobRequestByDocumentsAndRequestMethods
  extends StartExportInputValuesJobRequestBase {
  documents: Array<string>; // 추출할 문서 id
  requestMethods: Array<string>; // 문서목록 조회할 때 응답이 오는 creationInfo
}

interface StartExportInputValuesJobRequestByLabelIds extends StartExportInputValuesJobRequestBase {
  labels: string[];
}

type StartExportInputValuesJobRequest =
  | StartExportInputValuesJobRequestByDocuments
  | StartExportInputValuesJobRequestByRequestMethods
  | StartExportInputValuesJobRequestByDocumentsAndRequestMethods
  | StartExportInputValuesJobRequestByLabelIds;

export interface StartExportInputValuesJobResponse {
  id: string;
  fileUpdateJobId: string;
  requester: {
    id: string;
    name: string;
    email: string;
    message: string | null;
    ipAddress: string;
    userAgent: string;
    status: ExportInputValuesStatus;
  };
  createdAt: string;
  updatedAt: string;
  timeoutAt: number;
  completedAt: string;
}

interface ExportInputValuesJobsResponse {
  id: string;
  status: ExportInputValuesStatus;
  documentName: string | null;
  documentCount: number | null;
  successDocumentCount: number | null;
  failureDocumentCount: number | null;
}

export interface GetExportInputValuesJobsResponse {
  count: number;
  jobs: ExportInputValuesJobsResponse[];
}

export interface ExportInputValuesStatusByJobIdResponse {
  id: string;
  status: ExportInputValuesStatus;
  documentCount: number;
  successDocumentCount: number;
  failureDocumentCount: number;
  failureMessage: string | null;
  inProgressDocumentCount: number;
  url: string | null;
  createdAt: string;
  updatedAt: string;
  timeoutAt: number;
  completedAt: string | null;
  expireAt: string;
}

export function startExportInputValuesJob(
  workspaceId: string,
  data: StartExportInputValuesJobRequest
) {
  return requestApi<StartExportInputValuesJobResponse>({
    method: 'POST',
    url: withDocument(`/workspaces/${workspaceId}/export-input-values-jobs`),
    credentials: true,
    data,
  }).then((response) => response.data);
}

export function getExportInputValuesJobs(workspaceId: string) {
  return requestApi<GetExportInputValuesJobsResponse>({
    method: 'GET',
    url: withDocument(`/workspaces/${workspaceId}/export-input-values-jobs`),
    credentials: true,
  }).then((response) => response.data);
}

export function getExportInputValuesStatusByJobId({
  workspaceId,
  jobId,
}: {
  workspaceId: string;
  jobId: string;
}) {
  return requestApi<ExportInputValuesStatusByJobIdResponse>({
    method: 'GET',
    url: withDocument(`/workspaces/${workspaceId}/export-input-values-jobs/${jobId}`),
    credentials: true,
  }).then((response) => response.data);
}
